// src/pages/learners/AdminLearnerPortal.jsx
import { useEffect, useState } from "react";
import apiAuth from "@/api/auth";

export default function AdminLearnerPortal() {
  const [src, setSrc] = useState("");

  useEffect(() => {
    try {
      localStorage.setItem("kzTheme", "white");
      localStorage.setItem("kuizyTheme", "white");
      localStorage.setItem("kz:theme", "white");
    } catch { }
    setSrc(new URL("/learn/home", window.location.origin).toString());

  }, []);

  return (
    <div className="w-full h-[calc(100vh-64px)]">
      {src ? (
        <iframe
          title="Learner Portal"
          src={src}
          className="w-full h-full border-0"
          allow="fullscreen; clipboard-read; clipboard-write"
        />
      ) : null}
    </div>
  );
}
